import React from "react";
import Paper from "@mui/material/Paper";
import FormFader from "../Common/Fader/FormFader";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import { useForm } from "../../../provider/Form/FormProvider";
import ValidatorTextField from "../../FormFields/ValidatorTextField";
import { requiredValidator } from "../../../services/validationRules";
import Typography from "@mui/material/Typography";
import FormLegend from "../Common/FormLegend/FormLegend";
import FormSubmitProps from "../../../types/FormSubmitProps";
import wizardStyle from "../wizardStyle";
import { Box } from "@mui/material";
import { translate } from "../../../services/translations/translations";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import _ from "lodash";

type PersonalMessageProps = {
  submitProps: FormSubmitProps;
  validatorMessage?: string;
  product: AbstractCase;
  applicationStatus: number;
};

//this personalTextMessage field will be refactored into the AbstractLitigationCase thats why its already
//in this folder otherwise this would be in the AbstractCase folder
export default function PersonalMessage({ product, submitProps, validatorMessage, applicationStatus }: PersonalMessageProps) {
  const { handleSubmit } = useForm();

  const productWithCurrentApplicationStatus = { ..._.cloneDeep(product), applicationStatus };

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            {translate(`${product.name}.personalMessage.stepHeadline`, productWithCurrentApplicationStatus)}
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "flex-start",
              alignItems: "baseline",
            }}
          >
            <Grid size={12}>
              <FormLegend>
                <strong>{translate(`${product.name}.personalMessage.headline`, productWithCurrentApplicationStatus)}</strong>
              </FormLegend>
            </Grid>
            <Grid sx={wizardStyle.gridTopSpaced} size={12}>
              <FormLegend>{translate(`${product.name}.personalMessage.mainDescription`, productWithCurrentApplicationStatus)}</FormLegend>
            </Grid>
            <Grid size={12}>
              <ValidatorTextField
                name="personalTextMessage"
                label={translate(`${product.name}.personalMessage.label`, productWithCurrentApplicationStatus)}
                InputLabelProps={{
                  shrink: true,
                }}
                multiline
                rows={10}
                validators={[requiredValidator(validatorMessage || "Bitte schildern Sie uns hier kurz Ihre Situation und Ihre Fragen.")]}
              />
            </Grid>
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
